module.exports = __webpack_public_path__ + "static/img/summer_cans.f9ae8f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/summer/summer_cans.png
// module id = BDwi
// module chunks = 0